import { Reducer } from 'redux';
import { TeamActionTypes, TeamState } from './types';

const initialState: TeamState = {
  toggleTeamBoundary: true
};

const reducer: Reducer<TeamState> = (state = initialState, action: any) => {
  switch (action.type) {
    case TeamActionTypes.SET_CURRENT_TEAM: {
      return {
        ...state,
        currentTeamId: action.payload.id > 0 ? action.payload.id : undefined,
        currentTeamName:
          action.payload.id > 0 ? action.payload.name : undefined,
        currentTeamBaseMapType:
          action.payload.id > 0 ? action.payload.baseMapType : undefined,
        currentTeamBaseMapId:
          action.payload.id > 0 ? action.payload.baseMapId : undefined,
        currentTeamShape:
          action.payload.id > 0 ? action.payload.shape : undefined,
        currentTeamDefaultValues:
          action.payload.id > 0 ? action.payload.teamDefaultValues : undefined
      };
    }
    case TeamActionTypes.DISABLE_TEAM_PICKER: {
      return {
        ...state,
        teamPickerDisabled: action.payload
      };
    }
    case TeamActionTypes.RESET_CUSTOM_TEAM_BASE_MAP:
      return {
        ...state,
        currentTeamBaseMapToken: undefined,
        customBaseMapKey: undefined,
        customBaseMapSecret: undefined
      };
    case TeamActionTypes.SET_CUSTOM_TEAM_BASE_MAP_CREDENTIAL:
      return {
        ...state,
        customBaseMapKey: action.payload.key,
        customBaseMapSecret: action.payload.secret
      };
    case TeamActionTypes.GET_CUSTOM_TEAM_BASE_MAP_TOKEN_SUCCESS:
      return {
        ...state,
        currentTeamBaseMapToken: action.payload
      };
    case TeamActionTypes.GET_CUSTOM_TEAM_BASE_MAP_TOKEN_FAILURE:
      return {
        ...state,
        currentTeamBaseMapToken: action.payload
      };
    case TeamActionTypes.GET_TEAMS_LIST_START: {
      return {
        ...state,
        teamsList: [],
        loadingTeamsList: true
      };
    }
    case TeamActionTypes.GET_TEAMS_LIST_SUCCESS: {
      return {
        ...state,
        teamsList: action.payload,
        loadingTeamsList: false
      };
    }
    case TeamActionTypes.GET_TEAMS_LIST_FAILURE: {
      return {
        ...state,
        teamsList: [],
        loadingTeamsList: false
      };
    }
    case TeamActionTypes.SET_TEAM_BOUNDARY_TOGGLE: {
      return {
        ...state,
        toggleTeamBoundary: action.payload
      };
    }
    default:
      return state;
  }
};

export { reducer as TeamReducer };
